import React from 'react'
import RoutesConfig from '@/config/router/RoutesConfig'
import { useSelector } from 'react-redux'
import { intersection } from 'lodash'
import { useLocation } from 'react-router-dom'
import { Link as RouterLink } from 'react-router-dom'
import MuiLink from '@mui/material/Link'
import { useTranslation } from 'react-i18next'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemButton from '@mui/material/ListItemButton'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Avatar from '@mui/material/Avatar'
import { useTheme } from '@mui/material'
import useClasses from '@/components/hooks/UseClasses'

const styles = () => ({
  menuDrawer: {
    minWidth: '15%',
  },
})

const MenuBar = ({ open, setOpen, headerHeight }) => {
  const theme = useTheme()
  const classes = useClasses(styles)
  const roles = useSelector(({ login }) => login.roles)
  const user = useSelector(({ login }) => login)
  const { t } = useTranslation()
  const location = useLocation()
  const isArrayWithLength = (arr) => {
    return Array.isArray(arr) && arr.length
  }

  const listMenu = RoutesConfig.filter(({ menu, permission }) => {
    if (!menu) return false
    if (!permission) return true
    else if (!isArrayWithLength(permission)) return true
    else return intersection(permission, roles).length
  })
  const parents = listMenu
    ?.filter((l) => l.menu.parent)
    .map((l) => l.menu.parent)
    .filter((parent, index, arr) => arr.indexOf(parent) == index)
    .sort()

  let listWithParents = []
  parents.forEach((p) => listWithParents.push(listMenu?.filter((l) => l.menu.parent === p)))

  const showItem = (header) => (
    <Typography variant="h6" sx={{ my: 1, pl: 1 }}>
      {header}
    </Typography>
  )

  const showList = (listToShow, header) => (
    <>
      <Divider />
      {header && showItem(header)}
      <List>
        {listToShow.map((option) => {
          const isExternal = option.external === true
          return (
            <MuiLink
              key={option.title}
              component={isExternal ? 'a' : RouterLink}
              {...(isExternal
                ? { href: option.menu.acces, target: '_blank', rel: 'noopener noreferrer' }
                : { to: option.menu.acces })}>
              <ListItemButton selected={location.pathname === option.menu.acces ? true : false}>
                {option.menu.icon && <ListItemIcon>{option.menu.icon}</ListItemIcon>}
                <ListItemText primary={t(option.menu.label)} />
              </ListItemButton>
            </MuiLink>
          )
        })}
      </List>
    </>
  )

  const list = () => (
    <Box sx={{ overflow: 'auto' }} role="presentation" onClick={() => setOpen(false)} onKeyDown={() => setOpen(false)}>
      <ListItem>
        <Avatar color="primary">{user?.name?.substring(0, 1)}</Avatar>
        <Typography variant="h6" sx={{ my: 2 }} style={{ marginLeft: '10px' }}>
          {user?.name}
        </Typography>
      </ListItem>
      <Divider />
      {showList(listMenu?.filter((l) => !l.menu.parent))}
      {listWithParents?.map((l, index) => (
        <div key={index}> {showList(l, t('HEADER.' + l[0].menu.parent))}</div>
      ))}
    </Box>
  )
  return (
    <div style={{ backgroundColor: 'red' }}>
      <SwipeableDrawer
        slotProps={{
          paper: {
            sx: { backgroundColor: theme.palette.neutrals.n00.color },
          },
        }}
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        sx={{
          '& .MuiDrawer-paper': {
            top: `${headerHeight}px`,
            height: `calc(100% - ${headerHeight}px)`,
          },
        }}
        ModalProps={{
          keepMounted: true,
        }}
        classes={{
          paper: classes.menuDrawer,
        }}>
        {list()}
      </SwipeableDrawer>
    </div>
  )
}

export default MenuBar
